<style>
  .custom-loader {
    animation: loader 1s infinite;
    position: absolute;
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>

<template>
  <div
    style="display: flex; justify-content: flex-end; width: 100%; position: relative;"
  >
    <v-spacer v-if="!$store.state.isEditingToolsVisible"/>

    <div style="display: flex; justify-content: space-between; width: 100%; gap: 20px;">

      <v-btn
        @click="(event) => downloadModel(event, true)"
        :disabled="isBuildGSButtonDisabled"
        class="ma-2"
        color="success"
        :small="$store.state.mode !== 'static'"
        style="margin: 0 !important; padding: 0 8px;"
      >
        <template v-slot>
          <span
            style="align-items: center; display: flex; font-size: 10px;"
            :style="$store.state.buildingGS ? { opacity: 0 } : { opacity: 1 }"
          >
            <v-icon light style="font-size: 20px;">mdi-google-spreadsheet</v-icon>
            <div style="margin-left: 5px; text-align: left; flex-direction: column;">
              <span :style="$store.state.mode === 'static' ? 'font-size: 12px' : 'font-size: 10px'">
                {{ translate('ui_generate_gs_preview_btn_label') }}
              </span>
            </div>
          </span>

          <span
            :style="$store.state.buildingGS ? { opacity: 1 } : { opacity: 0 }"
            style="position: absolute;"
          >
              <v-icon light class="custom-loader" style="font-size: 18px;">mdi-google-spreadsheet</v-icon>
              <span class="d-none d-md-inline" v-if="$store.state.buildingGS" style="text-transform: none; margin-left: 4px; letter-spacing: normal;">
                {{ translate('ui_generate_gs_btn_please_wait') }}
              </span>
            </span>
        </template>
      </v-btn>

      <BuyBtn :template="$store.state.activeTemplate" :size="$store.state.mode !== 'static' && 'small'"/>

    </div>
  </div>
</template>

<script>
import Mixin from '@/mixins/mixin';
import BuyBtn from '@/components/BuyBtn.vue';

export default {
  name: 'TemplateToolbarStatic',
  components: { BuyBtn },
  mixins: [Mixin],
  props: [],
  data: () => ({
    showTooltip: false,
  }),
  methods: {
    downloadModel(event, isGoogleSheets) {
      event.stopPropagation();
      this.$store.dispatch('downloadModel', isGoogleSheets);
    },
  },
  computed: {
    hasSalesResources() {
      return this.$store.state.activeTemplate.data.divisions[0].sectionResources.some((sr) => sr.coreResource.rel === 'service');
    },
    isBuildGSButtonDisabled() {
      const isBuildingGS = this.$store.state.buildingGS;
      return isBuildingGS || !this.hasSalesResources;
    },
  },
};
</script>
